var Backbone = require('backbone');
var template = require('../templates/winner.ejs');

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-winner',
    /**
     *
     */
    initialize: function(options) {
        this.model = options.model;
        this.model.winnerCopy = options.model.paragraph1.replace('{winner}','<span>'+options.model.winner_name+'</span>');
    },
    /**
     *
     */
    render: function() {
        this.$el.html(template(this.model));
        return this;
    },
    /**
     *
     */
    remove: function() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }

});



// WEBPACK FOOTER //
// ./app/scripts/views/winner.js